<template>
  <van-nav-bar :fixed="true" :border="false" style="z-index: 999;">
    <template #title>
        <span style="color: #fff;">{{ safeTitle }}</span>
    </template>
    <template #left>
      <div @click="leftAreaClick()">
        <van-icon
          :name="safeLeftIcon"
          v-if="safeLeftType == 'vant'"
          color="#fff"
        />
        <img v-else class="head-left-icon" :src="safeLeftIcon" />
        <span style="color: #fff">{{ safeLeftText }}</span>
      </div>
    </template>
    <template #right>
      <div @click="rightAreaClick()">
        <span style="color: #fff">{{ safeRightText }}</span>
        <van-icon
          :name="safeRightIcon"
          v-if="safeRightType == 'vant'"
          color="#fff"
        />
        <img v-else class="head-left-icon" :src="safeRightIcon" />
      </div>
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'WebHeaderView',
  props: [
    'title',
    'leftIcon',
    'leftType',
    'leftText',
    'leftKey',
    'rightIcon',
    'rightText',
    'rightKey',
    'rightType'
  ],
  computed: {
    safeTitle () {
      return this.title || ''
    },
    safeLeftIcon () {
      return this.leftIcon || 'arrow-left'
    },
    safeLeftType () {
      return this.leftType || 'vant'
    },
    safeLeftText () {
      return this.leftText || ''
    },
    safeLeftKey () {
      return this.leftKey || 'back'
    },
    safeRightIcon () {
      return this.rightIcon || require('../../assets/images/headericon/menu.png')
    },
    safeRightType () {
      return this.rightType || 'img'
    },
    safeRightText () {
      return this.rightText || ''
    },
    safeRightKey () {
      return this.rightKey || 'usrmenu'
    }
  },
  methods: {
    leftAreaClick () {
      if (this.safeLeftKey == 'back') {
        this.$router.back()
      } else {
        this.$router.push({ name: this.safeLeftKey })
      }
    },
    rightAreaClick () {
      if(this.safeRightKey == 'usrmenu'){
         this.$parent.$parent.toShowUsrMenu()
      }
      else{
      this.$router.push({ name: this.safeRightKey })
      }
    }
  }
}
</script>
<style scoped>
.head-left-icon {
  height: 24px;
}
</style>
